// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2T0qa","col":"styles_col__2na96","fulfillmentStatus":"styles_fulfillmentStatus__2t6kz","emailCol":"styles_emailCol__SM_07"};